export const pools = [
  {
    pid: 0,
    stakedTokenName: "XY",
    stakedTokenSymbol: "XY",
    rewardTokenName:"XY",
    stakedTokenDecimals: 18,
    tokenAddress: "0x55555555A687343C6Ce28C8E1F6641dc71659fAd",
    poolAddress: "0xDc81b9DAfeefdADEE29e36E289968a37De56C510",
    getUrl:"https://legacy.quickswap.exchange/#/swap?inputCurrency=0x2791bca1f2de4661ed88a30c99a7a9449aa84174&outputCurrency=0x55555555A687343C6Ce28C8E1F6641dc71659fAd",
    weight: 0.2,
    toFixed: 2
  },
  {
    pid: 1,
    stakedTokenName: "XY:USDC LP",
    stakedTokenSymbol: "XY:USDC LP",
    rewardTokenName:"XY",
    stakedTokenDecimals: 18,
    tokenAddress: "0xa97cc9ffaa625e18d12e2f739378e94120e73782",
    poolAddress: "0x4F51687D1C465eb65167B2A9fC6bc28c2b39325c",
    getUrl:"https://legacy.quickswap.exchange/#/add/0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174/0x55555555A687343C6Ce28C8E1F6641dc71659fAd",
    weight: 0.8,
    toFixed: 8
  },
];
